@if (operation) {
	<tec-collapse
		[icon]="'icon-smartphone'"
		[title]="'PROCESSES.DETAIL.TFA' | translate"
		[tags]="[
			{
				label: ('MASTER.STATUS.' + tfaStatusKey(operation.state) | translate),
				status: masterService.getTagStatus(tfaStatusKey(operation.state)),
			},
		]"
		[expanded]="expanded"
		(clickEvent)="toggleCollapse.emit($event)"
	>
		<app-developer-curl-button
            ngProjectAs="tec-button-icon"
			[path]="operationCurlPath"
			titleKey="PROCESSES.CURL_MODAL.TITLE_OPERATION"
		/>
		@if (operation.state !== OPERATION_STATUS.INIT && operation.state !== OPERATION_STATUS.NOT_STARTED) {
			<tec-tile [title]="'PROCESSES.DETAIL.DETAILS' | translate">
				<div class="grid grid-i3">
					<tec-info-group [label]="'PROCESSES.DETAIL.TFA_PHONE' | translate">
						<app-phone-display [tfa]="operation" />
					</tec-info-group>
					<tec-info-group [label]="'PROCESSES.DETAIL.TFA_CHANNEL' | translate">
						<span>{{ tfaChannelLabel(operation) }}</span>
					</tec-info-group>
					<tec-info-group [label]="'PROCESSES.DETAIL.NUM_TRIED' | translate">
						<tec-tag
							[label]="
								operation.total_tries != null
									? operation.total_tries.toString()
									: ('GENERAL.NOT_AVAILABLE' | translate)
							"
						></tec-tag>
					</tec-info-group>
				</div>
				<tec-divider></tec-divider>
				<div class="grid grid-i3">
					<tec-info-group [label]="'PROCESSES.DETAIL.START_DATE' | translate">
						<tec-icon name="icon-calendar"></tec-icon>
						<span>{{
							(operation.start_at | safeDate: 'dd/MM/yyyy - HH:mm') ||
								('GENERAL.NOT_AVAILABLE' | translate)
						}}</span>
					</tec-info-group>
					<tec-info-group [label]="'PROCESSES.DETAIL.END_DATE' | translate">
						<tec-icon name="icon-calendar"></tec-icon>
						<span>{{
							(operation.end_at | safeDate: 'dd/MM/yyyy - HH:mm') ||
								('GENERAL.NOT_AVAILABLE' | translate)
						}}</span>
					</tec-info-group>
					<tec-info-group [label]="'PROCESSES.DETAIL.DURATION' | translate">
						<tec-icon name="icon-clock" size="xs" />
						<span>{{
							formatSecondsToMinutes(operation.total_time) || ('GENERAL.NOT_AVAILABLE' | translate)
						}}</span>
					</tec-info-group>
				</div>
			</tec-tile>
		} @else {
			<tec-empty-state
				[title]="'GENERAL.NO_DATA' | translate"
				[size]="'default'"
				[type]="'empty'"
			></tec-empty-state>
		}
	</tec-collapse>
}
